/*!
 *
 *   @bornfight/gocart v1.0.9
 *
 *
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *
 */

var Shopify = Shopify || {};
class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your cart is currently empty!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
            customerTags: '${{customerTags}}'
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
        this.customerTags = this.defaults.customerTags;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {
        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) {
            this.addToCart.forEach((item) => {

                item.addEventListener('click', (event) => {
                    event.preventDefault();

                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    try {
                        const response = window.openPopup();
                        if (response) {
                            this.addItemToCart(formID);
                        }
                    } catch (error) {
                        this.addItemToCart(formID);
                    }
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

    }

    fetchCart(callback) {
        const defaultRoute = Shopify.routes.root

        window.fetch(defaultRoute +'cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => {
                eval(cart);
                this.fetchHandler(window.cart, callback);
                this.renderUpsell(window.cart);

                document.dispatchEvent(
                    new CustomEvent("CartUpdated",{bubbles:true,detail:window.cart})
                );

            })
            .catch((error) => {
                console.error(error);
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, {hash: true});
        formData.quantity = formData.quantity ? `${Math.max(...formData.quantity)}` : '1';
        const button = form.querySelector('button[type="submit"].add-to-cart');
        const addToCartButtons = form.querySelectorAll('button[type="submit"].add-to-cart');
        const originalText = button.innerText;
        addToCartButtons.forEach((button) => {
            button.disabled = true;
            button.innerText = 'Adding...';
            button.classList.toggle('forced-hover');
        });
        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => this.addItemToCartHandler(product))
            .finally(() => {
                addToCartButtons.forEach((button) => {
                    button.disabled = false;
                    button.innerText = 'Added';
                    button.classList.toggle('forced-hover');
                });

                setTimeout(() => {
                    addToCartButtons.forEach((button) => {
                        button.innerText = originalText;
                    });
                }, 1500)
            })
            .catch((error) => {
                addToCartButtons.forEach((button) => {
                    button.innerText = originalText;
                    button.disabled = false;
                });
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    getTopUpsellItems(data) {
        const frequencyMap = {};

        // Count occurrences of each product id
        data.forEach(item => {
            frequencyMap[item.id] = (frequencyMap[item.id] || 0) + 1;
        });

        const uniqueItems = [];
        const seen = new Set();

        // Build unique items with count
        data.forEach(item => {
            if (!seen.has(item.id)) {
                if (!item.title) return

                seen.add(item.id);
                uniqueItems.push({ ...item, count: frequencyMap[item.id] });
            }
        });

        // Sort descending by count, return top 3
        return uniqueItems
            .sort((a, b) => b.count - a.count)
            .slice(0, 3);
    }


    fiterUpsellItems(cart, upsell) {
        return upsell.filter(item => !cart.some(line => Number(line.id) === item.first_variant_id))
    }

    async fetchUpsell() {
        const res = await fetch('/cart?section_id=cart-upsell');
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const upsellJson = doc.getElementById('upsell-json');

        if (upsellJson) {
            try {
                const json = JSON.parse(upsellJson.textContent);
                return json;
            } catch (err) {
                console.error('Error parsing JSON:', err);
            }
        }

        return null;
    }

    toggleUpsellVisibility(hasUpsell) {
        const upsellSection = document.querySelector('.js-cart-upsell-container');

        if (upsellSection) {
            upsellSection.style.display = hasUpsell ? 'block' : 'none';
        }
    }

    async renderUpsell(cart) {
        const cartUpsell = document.querySelector('.js-cart-upsell');
        const upsellJSON = await this.fetchUpsell();

        if (!upsellJSON && !cart && !cartUpsell) return;

        const upsellDataFiltered = this.fiterUpsellItems(cart.items, upsellJSON)

        const upsellData = this.getTopUpsellItems(upsellDataFiltered);

        this.toggleUpsellVisibility(upsellData.length > 0)

        console.log('upsellData', upsellData);

        const currentItems = Array.from(cartUpsell.children);

        upsellData.forEach((item, index) => {
            const existing = currentItems[index];
            const newId = String(item.id);

            // Create new upsell DOM node
            const upsellElement = document.createElement('div');
            upsellElement.className = 'go-cart-item__single';
            upsellElement.dataset.product = newId;
            upsellElement.innerHTML = `
                <div class="go-cart-item__info-wrapper">
                    <a href="${item.url}">
                        <div class="go-cart-item__image complementary" style="background-image: url(${item.featured_image})"></div>
                    </a>
                    <div class="go-cart-item__info">
                        <a href="${item.url}" class="go-cart-item__title body1 color-gashina">${item.title}</a>
                        <div class="product-reviews-summary reviews-actions short">
                            <a class="action view" href="${item.url}#reviews">
                                <div class="rating-summary">
                                    <span class="junip-product-summary" data-product-id="${item.id}"></span>
                                </div>
                            </a>
                        </div>
                        <a href="${item.url}" class="go-cart-item__title body1 color-gashina">${item.price}</a>
                    </div>
                    <div class="button-wrapper justify-content-center">
                        <form method="post" action="/cart/add" enctype="multipart/form-data" data-productid="${item.id}" id="add-to-cart-${item.handle}">
                            <input type="hidden" name="id" value="${item.first_variant_id}" />
                            <input min="1" type="number" id="quantity" name="quantity" value="1" class="visuallyhidden"/>
                            <button type="submit" class="button js-go-cart-add-to-cart add-to-cart" data-add-to-cart>Add</button>
                        </form>
                    </div>
                </div>
            `;

            // Replace existing or insert at position
            if (existing) {
                cartUpsell.replaceChild(upsellElement, existing);
            } else {
                cartUpsell.appendChild(upsellElement);
            }
            
            // Add button listener
            upsellElement.querySelector('.js-go-cart-add-to-cart').addEventListener('click', (event) => {
                event.preventDefault();
                const form = upsellElement.querySelector('form');
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            });
        });

        // Remove extra upsell slots if any
        while (cartUpsell.children.length > upsellData.length) {
            cartUpsell.removeChild(cartUpsell.lastElementChild);
        }
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
                document.querySelector('.go-cart-drawer__footer-wrapper').style.display = 'none';
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                document.querySelector('.go-cart-drawer__footer-wrapper').style.display = 'block';
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ?
              `<p class="go-cart-item__title body2">${product.product_title} ${productVariant}</p>` :
              `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {

        var rebuyContent = this.getCartRebuyContent();
        this.clearCartDrawer();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            if (item.discounts && item.discounts.length>0) {
              itemVariant = item.discounts[0].title;
            }
            let price = formatMoney(item.line_price, this.moneyFormat);
            let old_price = "";
            if (item.line_price<item.original_line_price) {
              old_price = `<s>$${(item.original_price/100).toFixed(2)}</s> `;
            }
            let is_gwp = item.properties && item.properties['_cr_gwp'];
            let price_string = `${old_price}${price.split(" ")[0]}`;
            if (is_gwp) {
                price_string = old_price;
            }

            const plan = item?.selling_plan_allocation?.selling_plan?.name;

            const cartSingleProduct = `
              <div class="go-cart-item__single ${(is_gwp)?"gwp-item":""}" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <a ${is_gwp ? '' : `href="${item.url}"`}>
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                  </a>
                  <div class="go-cart-item__info">
                    ${item.product_tags.includes(this.hiddenItemTag) ?
                    `<p class="go-cart-item__title body1 color-gashina">${item.product_title}</p>` :
                    (is_gwp ?
                    `<a class="go-cart-item__title body1 color-gashina">${item.product_title}</a>` :
                    `<a href="${item.url}" class="go-cart-item__title body1 color-gashina">${item.product_title}</a>`)}
                    <div class="go-cart-item__variant go-cart-item__discount body2 ${(is_gwp)?"gwp-item":""}">${itemVariant}</div>
                    ${plan !== undefined ? '<div class="go-cart-item__variant go-cart-item__plan body2">' + plan + '</div>' : ''}
                    <div class="go-cart-price-qty body1">
                      <div class="go-cart-item__price h6 color-gashina ${(is_gwp)?"gwp-item":""}">
                        ${price_string}
                        ${is_gwp?`<p>Free</p>`:""}
                      </div>
                      <div class="go-cart-item__quantity body1 ${(is_gwp)?"gwp-item":""}">
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                        <input class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${item.quantity}" disabled>
                        ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                      </div>
                    </div>
                  </div>
                </div>
                <a class="go-cart-item__remove body2 color-gashina ${this.removeFromCartNoDot}">
                  <svg width="13" height="14" xmlns="http://www.w3.org/2000/svg">
                  <g stroke="#969492" stroke-width="1.2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 3.769h11.077M2.385 3.77h8.307v8.307c0 .51-.413.923-.923.923H3.308a.923.923 0 0 1-.923-.923V3.769Z"></path>
                  <path d="M4.23 3.77v-.462a2.308 2.308 0 0 1 4.616 0v.461M5.154 5.615v5.077M7.923 5.615v5.077"></path></g></svg>
                </a>
              </div>`;
            this.cartDrawerContent.innerHTML += cartSingleProduct;

        });

		rebuyContent.forEach(widget=>this.cartDrawerContent.appendChild(widget));

        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
              console.error("plus");
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
		rebuyContent.forEach(widget=>this.cartDrawerContent.appendChild(widget));

      this.updateShippingMotivator();
      document.dispatchEvent(
        new CustomEvent("CartUpdated",{bubbles:true,detail:''})
      );
    }
    updateShippingMotivator() {

      let motivator = document.querySelector(".cart-shipping-bar");
      let bar = document.querySelector(".cart-free-shipping");
      let text = document.querySelector(".cart-more-shipping");
      let discountText = document.querySelector(".cart-unlocked-free-shipping-hidden");

      if (this.customerTags && this.customerTags.includes('B2B')) {
        $(bar).hide();
        $(motivator).hide();
        $(text).hide();
        $(discountText).hide();
        return false;
      }

      let cart_total = window.cart.total_price;
      const currencySymbol =motivator.getAttribute("data-currency-symbol");

      // convert threshold and round
      let shipping_threshold = this.roundAndFormatCurrency(parseInt(motivator.getAttribute("data-shipping-threshold")));

      let gwp_tiers = motivator.getAttribute("data-gwp-tiers").split(",").map((element,index)=>this.roundAndFormatCurrency(element));
      gwp_tiers = gwp_tiers.map((element,index)=>[
        element,
        gwp_tiers[index+1]?gwp_tiers[index+1]-1:999999999999
      ]);
      let gwp_messages =  motivator.getAttribute("data-gwp-messages").split(",");
      let gwp_enabled = motivator.getAttribute("data-gwp-enabled")=="true";

      let max_gwp = gwp_tiers[gwp_tiers.length-1][0];

      let current_gwp_index = gwp_tiers.findIndex((tier)=>cart_total>=tier[0] && cart_total<=tier[1]);
      let current_gwp_tier = gwp_tiers[current_gwp_index]?gwp_tiers[current_gwp_index][0]:null;
      let next_gwp_tier = gwp_tiers[current_gwp_index+1]?gwp_tiers[current_gwp_index+1][0]:null;
      let gwp_message = `
        ${motivator.getAttribute("data-gwp-message-prefix")}
        ${(current_gwp_index>=0)?gwp_messages[current_gwp_index+1]:gwp_messages[0]}
      `;

      let perc = 100;
      let shortfall = 0;
      const isInternational = Shopify.country !== 'US';

      const cartUnlockedFreeShipping = $(".cart-unlocked-free-shipping-hidden");
      const internationalShippingWrapper =  $(".internation-shipping-wrapper-hidden");
      let message = isInternational ? motivator.getAttribute("data-unlocked-international") : motivator.getAttribute("data-unlocked");

      cartUnlockedFreeShipping.hide();
      internationalShippingWrapper.hide();
      document.querySelector('.go-cart-drawer__content').classList.remove('extended');

      if (isInternational) {
        cartUnlockedFreeShipping.hide();
        internationalShippingWrapper.show();
      }
      if (!isInternational && cart_total >= shipping_threshold) {
        cartUnlockedFreeShipping.show();
        document.querySelector('.go-cart-drawer__content').classList.add('extended');
      }
      if (current_gwp_tier && !next_gwp_tier) {
        text.innerHTML = message;
        bar.style.width = "100%";
      } else {
        if (!isInternational && cart_total < shipping_threshold) {
          perc = (((cart_total / shipping_threshold)) * 100);
          shortfall = ((shipping_threshold-cart_total)/100).toFixed(2);
          message = motivator.getAttribute("data-shipping-message").replace("##amount", currencySymbol + shortfall );
        } else {
          if (gwp_enabled) {

            // perc = ((((cart_total - shipping_threshold) / (max_gwp - shipping_threshold)) * 100) / 2 ) + 0;
            if(cart_total === 0) {
                text.innerHTML = '';
                return;
            }
            if (cart_total < 15000) {
              perc = ((cart_total / 100) - 100) * 2;
            }

            if (cart_total >= 15000 && cart_total < 20000) {
              perc = ((cart_total / 100) - 150) * 2;
            }

            if (cart_total >= 20000) {
              perc = ((cart_total / 100) - 200) * 2;
            }

            shortfall = ((next_gwp_tier-cart_total)/100).toFixed(2);
              message = gwp_message.replace("##amount",currencySymbol + shortfall)
          } else {
              text.innerHTML = message;
              perc = 100;
          }
        }
        text.innerHTML = message;
        bar.style.width = `${perc}%`;
      }
  }

    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ?
                        `<p class="go-cart-item__title body1">${item.product_title}</p>` :
                        `<a href="${item.url}" class="go-cart-item__title body1 color-gashina">${item.product_title}</a>`}
                        <div class="go-cart-item__variant body2 go-cart-item__discount">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
	    var rebuyContent = this.getCartRebuyContent();

        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="body1 go-cart__empty">${this.labelCartIsEmpty}</div>`;

		rebuyContent.forEach(widget=>this.cartDrawerContent.appendChild(widget));

        this.updateShippingMotivator();
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
        document.querySelector('body').style.overflow = 'hidden';
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
        document.querySelector('body').style.overflow = '';
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

	getCartRebuyContent() {
		let ret = [];
		document.querySelector(".js-go-cart-drawer-content").querySelectorAll("[data-rebuy-id]").forEach(node=>{
			ret.push(node);
			node.parentNode.removeChild(node);
		});
		return ret;
	}

    roundAndFormatCurrency(element) {
       return  Math.floor(parseInt(element * Shopify.currency.rate) / 100) * 100
    }

}

//export default GoCart;

